export default {
    _ffulbotano: "fulbotano"
}